
// src/actions/index.js

import assign from 'lodash/assign'
import reduce from 'lodash/reduce'

import * as account from './account'
import * as activityReport from './activity-report'
import * as alertMessage from './alert-message'
import * as announce from './announce'
import * as attachments from './attachments'
import * as buildNo from './build-no'
import * as chatMessages from './chat-messages'
import * as chatRooms from './chat-rooms'
import * as comments from './comments'
import * as diaries from './diaries'
import * as favorite from './favorite'
import * as block from './block'
import * as groups from './groups'
import * as homeDiaries from './home-diaries'
import * as homeNotifications from './home-notifications'
import * as homeSubDiaries from './home-sub-diaries'
import * as kpiChart from './kpi-chart'
import * as kpi from './kpi'
import * as likes from './likes'
import * as pins from './pins'
import * as notifications from './notifications'
import * as organizations from './organizations'
import * as preservedQueries from './preserved-queries'
import * as reactChat from './react-chat'
import * as savedDiaries from './saved-diaries'
import * as sessions from './sessions'
import * as subDiaries from './sub-diaries'
import * as subscribe from './subscribe'
import * as templates from './templates'
import * as uploadFile from './upload-file'
import * as uploadVideo from './upload-video'
import * as user from './user'
import * as users from './users'
import * as sidebar from './sidebar'
import * as socket from './socket'
import * as rightSidebar from './right-sidebar'
import * as googleAPI from './google-api'
import * as outlookAPI from './outlook-calendar'
import * as diaryForm from './diary-form'
import * as editDiary from './edit-diary'
import * as groupSettings from './group-settings'
import * as userSettings from './user-settings'
import * as deviceOrientation from './device-orientation'
import * as productTour from './product-tour'
import * as registrationUrl from './registration-url'
import * as accountOtherMembersCount from './account-other-members-count'
import * as urlInfo from './url-info'
import * as imagesView from './images-view'
import * as translate from './translate'
import * as dashboard from './dashboard'
import * as submissionSchedules from './submission-schedules'
import * as report from './report'
import * as diaryReport from './diary-report'
import * as divisions from './divisions'
import * as divisionSettings from './division-settings'
import * as divisionGroupManager from './divisions-group-manager'
import * as menus from './menus'
import * as review from './review'
import * as reviewSetting from './review-setting'
import * as showTimeStampSetting from './show-timestampe-setting'

const actions =
  reduce([
    account,
    activityReport,
    alertMessage,
    announce,
    attachments,
    buildNo,
    chatMessages,
    chatRooms,
    comments,
    diaries,
    favorite,
    block,
    groups,
    homeDiaries,
    homeNotifications,
    homeSubDiaries,
    kpiChart,
    kpi,
    likes,
    pins,
    notifications,
    organizations,
    preservedQueries,
    reactChat,
    savedDiaries,
    sessions,
    subDiaries,
    subscribe,
    templates,
    uploadFile,
    uploadVideo,
    user,
    users,
    sidebar,
    socket,
    rightSidebar,
    googleAPI,
    outlookAPI,
    diaryForm,
    editDiary,
    groupSettings,
    userSettings,
    deviceOrientation,
    productTour,
    registrationUrl,
    accountOtherMembersCount,
    urlInfo,
    imagesView,
    translate,
    dashboard,
    submissionSchedules,
    report,
    diaryReport,
    divisions,
    divisionSettings,
    divisionGroupManager,
    menus,
    review,
    reviewSetting, 
    showTimeStampSetting,
  ], (result, value)=> {
    return assign(result, value)
  }, {})

export default actions



// WEBPACK FOOTER //
// ./src/actions/index.js